<template>
  <section class="home-feature-section">
    <div class="home-feature-section__intro fall">
      <h2>Examen taxi vtc</h2>
      <p>
        L'examen <strong>T3P</strong> est une étape essentielle pour obtenir la
        <strong>carte professionnelle VTC</strong> ou taxi. Cet
        <strong>examen</strong> rigoureux évalue les connaissances et les
        compétences requises pour exercer ces métiers.
      </p>
    </div>

    <ServiceFeatureBlock
      class="slide-right"
      title="Préparation à l'examen T3P"
      tone="primary"
    >
      <template #media>
        <img
          src="@/assets/pictures/wayroom.webp"
          alt="class-room-for-taxi-learning"
          class="img-fluid"
          loading="lazy"
        />
      </template>

      L'<span>Institut</span> <span> Taxi</span>, prépare ses stagiaires à
      l'<strong>examen</strong> <strong>T3P</strong>, en leur fournissant les
      ressources et les <strong>formations</strong> nécessaires pour réussir.
      <br />
      Que vous visiez la <strong>carte professionnelle taxi</strong> ou VTC,
      notre équipe pédagogique expérimentée vous accompagnera dans votre
      préparation, en couvrant tous les aspects pertinents de l'examen
      <strong>T3P</strong>. Soyez prêt à franchir cette étape importante vers
      votre carrière de chauffeur professionnel. <br />
      Avec nos <strong>formations certifiantes</strong> et un accompagnement sur
      mesure, vous maximisez vos chances de réussite à l'<strong
        >examen T3P</strong
      >
      et démarrez votre nouvelle activité en toute sérénité.
    </ServiceFeatureBlock>
  </section>
</template>

<script>
import ServiceFeatureBlock from "@/components/services/ServiceFeatureBlock.vue";

export default {
  name: "HomeFirstSection",
  components: {
    ServiceFeatureBlock,
  },
  mounted() {
    import("@/assets/globalJs/global.js").then((module) => {
      const { observeElements } = module;
      observeElements(".slide-right", ".slide-left", ".fall");
    });
  },
};
</script>

<style lang="scss" scoped>
.home-feature-section {
  padding: clamp(74px, 9vw, 108px) 20px clamp(92px, 11vw, 126px);

  @media screen and (min-width: 768px) {
    padding-inline: 28px;
  }

  @media screen and (min-width: 992px) {
    padding: clamp(88px, 9vw, 116px) clamp(28px, 4vw, 56px)
      clamp(108px, 10vw, 136px);
  }

  &__intro {
    width: min(100%, 920px);
    margin: 0 auto 42px;
    padding: clamp(24px, 4vw, 38px) clamp(22px, 4.5vw, 42px);
    text-align: center;
    border-radius: 30px;
    background: #ffffff;
    box-shadow: 0 22px 48px rgba(0, 42, 84, 0.08),
      inset 0 1px 0 rgba(255, 255, 255, 0.94);

    &::before {
      content: "";
      display: block;
      width: 92px;
      height: 5px;
      margin: 0 auto 18px;
      border-radius: 999px;
      background: $color-secondary;
      box-shadow: 0 10px 18px rgba(254, 185, 20, 0.18);
    }

    h2 {
      margin: 0;
      color: $color-primary;
      font-family: "Spartan", "Arial Black", Arial, sans-serif;
      font-weight: 700;
      font-size: clamp(1.56rem, 1.18rem + 0.98vw, 2.3rem);
      line-height: 1.02;
      letter-spacing: 0.03em;
      text-shadow: 0 1px 0 rgba(255, 255, 255, 0.88),
        0 14px 28px rgba(0, 42, 84, 0.08);
    }

    p {
      margin: 16px auto 0;
      max-width: 760px;
      color: rgba(43, 43, 43, 0.88);
      font-family: "Roboto", "Helvetica Neue", Arial, sans-serif;
      font-size: clamp(1rem, 0.96rem + 0.18vw, 1.08rem);
      line-height: 1.78;
      letter-spacing: 0.01em;
    }
  }

  :deep(.serviceFeatureBlock__copy span:first-of-type) {
    color: $color-primary;
  }

  :deep(.serviceFeatureBlock__copy span:last-of-type) {
    color: $color-secondary;
  }
}

.slide-right.active {
  @include slide-right(1.2s);
}

.slide-left.active {
  @include slide-left(1.2s);
}

.fall.active {
  @include fall-down(1s);
}
</style>
